import React, { useCallback, useState, useRef, useEffect } from 'react';

const UserfeedChannel = ({ currentUser, userfeed, userfeedId, hashedCompanyId }) => {
  if (!userfeed || !userfeed.user || !currentUser) {
    return null;
  }

  return (
    <div 
      key={userfeed.id} 
      style={{
        width: '100%',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
      }}
    >
      <a 
        className="border-0 text-fz-13px"
        href={hashedCompanyId ? `/community/${hashedCompanyId}/userfeeds/${userfeed.id}` : `/userfeeds/${userfeed.id}`}
        style={{
          maxWidth: 0,
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
        }}
      >
        <p 
          className={`pl-2 pr-2 pt-1 pb-1 mb-1 align-items-center rounded ${userfeed.id === parseInt(userfeedId) ? 'bg-opacity-gray text-fw-bold' : ''}`}
          style={{
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            textOverflow: 'ellipsis',
          }}
        >
          {userfeed.body}
        </p>
      </a>
    </div>
  );
};


export default UserfeedChannel;